import { render } from "./NotebookEmbed.vue?vue&type=template&id=60df648c"
import script from "./NotebookEmbed.vue?vue&type=script&lang=js"
export * from "./NotebookEmbed.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__